export default "__VITE_PUBLIC_ASSET__8b617e23__"